<template>
<div class="booking-detail-left-side">
  <div class="bookingname f2 info-group">
    <div class="label f8">{{ $t('Reservation Name') }}</div>
    <div class="booking-name">{{ booking.title }}</div>
  </div>
  <div class="date-and-time info-group">
    <div class="label f8">{{ $t('Date & Number of Players') }}</div>
    <div class="datetop f2">{{ dateTop }}</div>
    <div class="guestlistcount f8">{{ booking.numPlayers }} {{ $tc('Player | Players', booking.numPlayers) }}</div>
  </div>
  <div class="bookingstationtimes info-group">
    <div class="label f8">{{ $t('Stations') }}</div>
    <div v-for="bookingStationTime in getBookingStationTimesWithDetails(booking)" :key="bookingStationTime.id" class="bookingstationtime">
      <div class="station f2">{{ bookingStationTime.station.title }}</div>
      <div class="date f8">{{ bookingStationTimeDate(bookingStationTime) }}</div>
      <div class="experience f6">{{ bookingStationTime.experience.title }}</div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';

@Component({
  props: {
    locationId: {
      type: String,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
    stations: {
      type: Array,
      required: true,
    },
    experiences: {
      type: Array,
      required: true,
    },
    isNetworkAvailable: {
      type: Boolean,
      required: true,
    },
  },
})
export default class BookingDetailLeftSide extends Vue {
  get dateTop () { return moment(this.booking.startTime).format('LL'); }

  getBookingStationTimesWithDetails (booking) {
    return booking.bookingStationTimes.map(bookingStationTime => {
      const station = this.stations.find(station => station.id === bookingStationTime.station.id);
      const experience = this.experiences.find(experience => experience.id === bookingStationTime.experience.id);
      return { ...bookingStationTime, station, experience };
    });
  }

  bookingStationTimeDate (bookingStationTime) {
    const start = moment(this.booking.startTime);
    const end = moment(bookingStationTime.endTime);
    return `${start.format('LT')} ${this.$t('to')} ${end.format('LT')} - ${bookingStationTime.tier.length} ${this.$tc('min | mins', bookingStationTime.tier.length)}`;
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.info-group {
  margin: var(--spacingMd) 0;

  &:first-child { margin-top: 0; }
  &:last-child { margin-bottom: 0; }

  & .label {
    margin-bottom: var(--spacingXS);
    color: var(--colorManatee);
  }

  & .datetop,
  & .station,
  & .bookingname {
    margin-bottom: var(--spacingXS);
  }

  & .guestlistcount,
  & .date {
    margin-bottom: var(--spacingXS);
  }

  & .bookingstationtime {
    margin-bottom: var(--spacingSm);

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
